import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import TechStack from "./TechStacks/TechStack";
import github from "../../assets/icons/github.svg";

//lazy loading

import { LazyLoadImage } from "react-lazy-load-image-component";
import LazyLoad from "react-lazy-load";

export default function SingleProjectCard({ data }) {
  const tech = data.tech;

  return (
    <LazyLoad>
      <Box sx={{}}>
        <LazyLoadImage effect="blur" img src={data.img} alt="" />
        <Typography
          sx={{
            mt: "8px",
            color: "white",
            mb: "8px",
            ml: "3px",
            fontFamily: "Titillium Web",
            fontWeight: "400",
          }}
        >
          {data.name}
        </Typography>
        <Stack direction="row" sx={{ mt: "5px" }} spacing={1}>
          {tech.map((val, key) => {
            return <TechStack key={key} tech={val} />;
          })}
        </Stack>
        <Stack direction="row" gap="5px" sx={{ mt: "10px" }}>
          <div
            style={{
              width: "80px",
              height: "25px",
              backgroundColor: " Black",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              //   border: " 2px solid skyblue",
              borderRadius: "15px",
              fontSize: "13px",
              gap: "5px",
            }}
          >
            <img
              src={github}
              alt=""
              style={{ width: "15px", height: "15px" }}
            />
            <span>
              <a
                href={data.git}
                style={{ textDecoration: "none", color: "white" }}
              >
                Github
              </a>
            </span>
          </div>
          {data.live && (
            <div
              style={{
                width: "80px",
                height: "25px",
                //   backgroundColor: " Black",
                color: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                //   border: " 2px solid skyblue",
                borderRadius: "15px",
                fontSize: "13px",
                gap: "5px",
              }}
            >
              <span>
                <a
                  href={data.liveLink}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  LIVE
                </a>
              </span>
              <div class="blob"></div>
            </div>
          )}
        </Stack>
      </Box>
    </LazyLoad>
  );
}
